import type { TooltipProps } from '@mui/material/Tooltip';

import { useTheme } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

interface CustomTooltipProps extends TooltipProps {
  children: React.ReactElement<any, any>;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  title,
  children
}) => {
  const theme = useTheme();
  const background = theme.palette.background.paper;

  return (
    <Tooltip
      title={title}
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            borderRadius: '5px',
            background,
            boxShadow: '4px 4px 4px 0px rgba(0, 0, 0, 0.25)',
            color: theme.palette.text.primary,
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;